import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[spDetectColor]',
})
export class DetectColorDirective implements AfterViewInit {
  
  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    const bgColor = getComputedStyle(this.el.nativeElement).getPropertyValue('background-color');
    const brightness = this.lightOrDark(bgColor);
    if (brightness == 'dark') {
      this.el.nativeElement.children[0].classList.add('text-white');
    } else {
      this.el.nativeElement.children[0].classList?.add('text-black');
    }
  }

  lightOrDark(color: string) {
    let r, g, b;
    // Check the format of the color => RGB?
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      const regexColor = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
      r = regexColor && regexColor[1];
      g = regexColor && regexColor[2];
      b = regexColor && regexColor[3];
    }
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    const hsp = Math.sqrt(
      0.299 * (Number(r) * Number(r)) + 0.587 * (Number(g) * Number(g)) + 0.114 * (Number(b) * Number(b)),
    );
    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return 'light';
    } else {
      return 'dark';
    }
  }
}
